import React from 'react';
import MultipleItemsRenderer from '../../../../core/table/renderers/MultipleItemsRenderer';
import utilSvc from '../../../../core/utilSvc';

const ExemptedStatesRenderer = <TItem extends object>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    const val = item[colKey];

    if (val.length === utilSvc.loc.stateNames().length) {
        return <p style={{ padding: 0 }}>ALL</p>;
    }

    return val.length > 1 ? (
        <MultipleItemsRenderer
            item={item}
            colKey={colKey}
        />
    ) : (
        <p style={{ padding: 0 }}>{val.length === 1 ? val[0] : ''}</p>
    );
};

export default ExemptedStatesRenderer;
